import { FaGithub, FaLinkedinIn } from 'react-icons/fa';

export const socialdata = [
  {
    name: 'linkedin',
    link: 'https://www.linkedin.com/in/yashix/',
    icon: <FaLinkedinIn className="navicon" />,
    username: 'yashix',
  },
  {
    name: 'github',
    link: 'https://github.com/Yashvanthk05/',
    icon: <FaGithub className="navicon" />,
    username: 'Yashvanthk05',
  },
];

export const sidedata = {
  name: 'Yashvanth Karunakaran',
  profile: 'pf.png',
  address: 'Chennai, Tamilnadu',
  cv: 'resume.pdf',
  desc: 'Software Developer',
  honor: 'He/Him',
  mail: 'yashvanthk05@gmail.com',
  phone: '91+9025242514',
};

export const aboutdata = [
  'Undergraduate in Computer Science (AIML)',
  'Backend engineer who enjoys building scalable systems and clean architecture',
  'Interested in System design, AI/ML, Development and problem solving',
];

export const edudata = [
  {
    logo: 'vit.png',
    name: 'Vellore Institute of Technology',
    from: 'Jun, 2023',
    to: 'Present',
    grade: 9.79,
    metric: 'CGPA',
    addr: 'Chennai, Tamilnadu',
    degree: 'CSE AIML',
    link: 'https://chennai.vit.ac.in/',
  },
  {
    logo: 'devi.png',
    name: 'Devi Academy Senior Secondary School',
    from: 'Apr, 2022',
    to: 'Apr, 2023',
    grade: 96.2,
    metric: '%',
    addr: 'Chennai, Tamilnadu',
    degree: 'AISSCE',
    link: 'https://deviacademy.ac.in/',
  },
  {
    logo: 'devi.png',
    name: 'Devi Academy Senior Secondary School',
    from: 'Apr, 2020',
    to: 'Apr, 2021',
    grade: 97.6,
    metric: '%',
    addr: 'Chennai, Tamilnadu',
    degree: 'AISSE',
    link: 'https://deviacademy.ac.in/',
  },
];

export const expdata = [
  {
    logo: 'vit.png',
    name: 'Daira Edtech Ltd.',
    position: 'Full Stack Dev',
    from: 'May, 2025',
    to: 'Aug, 2025',
    org: 'Chennai',
    addr: 'Tamilnadu',
  },
  {
    logo: 'vit.png',
    name: 'Center for Cyber Physical Systems',
    position: 'Research Intern',
    from: 'May, 2024',
    to: 'June, 2024',
    org: 'Vellore Institute of Technology',
    addr: 'Chennai, Tamilnadu',
  },
  {
    logo: 'mic.png',
    name: 'Microsoft Innovation Club',
    position: 'Web Dev',
    from: 'May, 2024',
    to: 'May, 2025',
    org: 'Vellore Institute of Technology',
    addr: 'Chennai, Tamilnadu',
  },
  {
    logo: 'gdg.png',
    name: 'Google Developers Group',
    position: 'Open Source Dev',
    from: 'Oct, 2024',
    to: 'May, 2025',
    org: 'Vellore Institute of Technology',
    addr: 'Chennai, Tamilnadu',
  },
  {
    logo: 'ospc.png',
    name: 'Open Source Programming Club',
    position: 'AI/ML Engineer',
    from: 'May, 2025',
    to: 'Jan, 2026',
    org: 'Vellore Institute of Technology',
    addr: 'Chennai, Tamilnadu',
  },
];

export const prodata = [
  {
    name: 'AuraLearn',
    link: 'https://github.com/Yashvanthk05/aura-learn',
    tech: ['FastAPI', 'FAISS', 'BM25', 'TF-IDF', 'Whisper', 'Python'],
    desc: 'Document Intelligence & RAG Backend with hybrid retrieval, multi-format ingestion, and audio transcription.',
  },
  {
    name: 'Channel',
    link: 'https://github.com/Yashvanthk05/channel',
    tech: ['ExpressJS', 'NodeJS', 'MongoDB', 'JWT', 'Zod', 'REST API'],
    desc: 'Markdown Blogging Platform with JWT auth, schema-validated CRUD APIs, and modular REST API design.',
  },
  {
    name: 'Launchly',
    link: 'https://github.com/Yashvanthk05/launchly',
    tech: ['EC2', 'API Gateway', 'S3', 'Lambda', 'ReactJS', 'ExpressJS', 'Javascript'],
    desc: 'Automated Web Deployment platform using AWS, Inspired by Vercel.',
  },
  {
    name: 'VSCHEDULE',
    link: 'https://vschedule.vercel.app/',
    tech: ['ReactJS', 'Javascript', 'Local Storage'],
    desc: 'VIT FFCS Timetable efficient planner along with conflict management and generation with backtracking.',
  },
  {
    name: 'Chefy',
    link: 'https://chefy-roan.vercel.app/',
    tech: ['Python', 'Yolo', 'Tensorflow', 'FastAPI', 'NextJS'],
    desc: 'Indian Food Recommendation by Ingredient Detection.',
  },
  {
    name: 'VASSIST',
    link: 'https://vassist-mu.vercel.app/materials',
    tech: ['Firebase Auth', 'Google Console', 'NextJS'],
    desc: 'PYQ and Study Material Platform for VIT Chennai.',
  },
];

export const certdata = [
  {
    name: 'AWS Solutions Architect',
    img: 'AWS.png',
    org: 'Amazon Web Services',
    issue: 'June 2026',
  },
  {
    name: 'CS50x: Introduction to Computer Science',
    img: 'CS50p.png',
    org: 'Harvard University',
    issue: 'May 2025',
  },
  {
    name: 'CS50p: Introduction to Programming with Python',
    img: 'CS50p.png',
    org: 'Harvard University',
    issue: 'May 2025',
  },
  {
    name: 'The Complete Full-Stack Web Development',
    img: 'web.jpg',
    org: 'Angela Yu (Udemy)',
    issue: 'May 2025',
  },
];

export const achievedata = [
  {
    name: 'Rank 2: AIML Deparment',
    img: 'CS50p.png',
    org: 'Vellore Institute of Technology, Chennai',
    issue: 'May 2025',
  },
  {
    name: 'Rank 9: Electronics and Computer Engineering Department',
    img: 'CS50p.png',
    org: 'Vellore Institute of Technology, Chennai',
    issue: 'May 2025',
  },
  {
    name: 'Ranked 2nd in Web Works Hackathon',
    img: 'CS50p.png',
    org: 'CYSCOM Club, VIT Chennai',
    issue: 'May 2025',
  },
  {
    name: 'Ranked 2nd in Juice Shop CTF',
    img: 'ctf.png',
    org: 'Android club, VIT Chennai',
    issue: 'May 2024',
  },
];
